// routes/settings_.legal.tsx
// -----------------------------------------------------------------------------
// Legal sub-page - Terms, Privacy, Community Guidelines links + Acknowledgements.
// -----------------------------------------------------------------------------

import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "@/lib/auth";
import { AppLayout, PageTransition, useHeaderConfig } from "@/components/layout";
import { Icon } from "@/components/ui/Icon";
import { AcknowledgementsPanel } from "@/components/settings/AcknowledgementsPanel";

export const Route = createFileRoute("/settings_/legal")({
  beforeLoad: requireAuth,
  component: LegalPage,
});

const legalItems = [
  {
    label: "Terms of Service",
    url: "https://tiny.club/legal/terms-of-service",
  },
  {
    label: "Privacy Policy",
    url: "https://tiny.club/legal/privacy-policy",
  },
  {
    label: "Community Guidelines",
    url: "https://tiny.club/legal/community-guidelines",
  },
];

function LegalPage() {
  const [showAcknowledgements, setShowAcknowledgements] = useState(false);

  useHeaderConfig(
    {
      breadcrumbs: [
        { label: "Settings", path: "/settings" },
        { label: "Legal" },
      ],
    },
    []
  );

  return (
    <AppLayout>
      <PageTransition>
        <div className="p-6 pb-24">
          <div className="max-w-lg mx-auto">
            <div className="bg-surface-1 rounded-2xl overflow-hidden">
              {legalItems.map((item, index) => (
                <div key={item.label}>
                  {index > 0 && (
                    <div className="h-px bg-border-subtle ml-12" />
                  )}
                  <button
                    className="flex items-center gap-3 p-4 w-full hover:bg-surface-2 transition-colors cursor-pointer text-left"
                    onClick={() => window.open(item.url, "_blank")}
                  >
                    <span className="text-body-1 text-text-primary flex-1">
                      {item.label}
                    </span>
                    <Icon
                      name="angle-right"
                      size={16}
                      className="text-text-secondary"
                    />
                  </button>
                </div>
              ))}

              {/* Acknowledgements */}
              <div className="h-px bg-border-subtle ml-12" />
              <button
                className="flex items-center gap-3 p-4 w-full hover:bg-surface-2 transition-colors cursor-pointer text-left"
                onClick={() => setShowAcknowledgements(true)}
              >
                <span className="text-body-1 text-text-primary flex-1">
                  Acknowledgements
                </span>
                <Icon
                  name="angle-right"
                  size={16}
                  className="text-text-secondary"
                />
              </button>
            </div>
          </div>
        </div>
      </PageTransition>

      <AcknowledgementsPanel
        open={showAcknowledgements}
        onOpenChange={setShowAcknowledgements}
      />
    </AppLayout>
  );
}
